import { RefObject, useEffect } from "react";

/** Closes a popover on a click outside `ref` or on Escape, while it is open. */
export const useDismiss = (
  ref: RefObject<HTMLElement>,
  open: boolean,
  onClose: () => void
) => {
  useEffect(() => {
    if (!open) return;

    const onMouseDown = (event: MouseEvent) => {
      if (!ref.current?.contains(event.target as Node)) onClose();
    };
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("mousedown", onMouseDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [ref, open, onClose]);
};
